import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/_layout/crm/")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/crm/accounts" });
  },
});
